import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	Layout,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React, { useRef } from 'react';
import { StyledSpinner } from '../styled-spinner/styled-spinner';
import { NovedadesCarousel } from './components/novedades-carousel';
import styled from 'styled-components';
import useSortedNovedades from './hooks/use-sorted-novedades';
import { novedadesBackgroundColor } from '../../helpers/color-tokens';

const Background = styled.div`
	background: ${novedadesBackgroundColor};
`;

export const Novedades = (): React.ReactElement => {
	const sectionRef = useRef<HTMLElement>(null);
	const novedades = useSortedNovedades();

	return (
		<Background>
			<section ref={sectionRef}>
				{novedades && novedades.length > 0 ? (
					<Container
						data-testid="novedades-container"
						padding={{
							top: {
								[Breakpoints.default]: ContainerPadding.dynamic0250,
								[Breakpoints.b560]: ContainerPadding.dynamic0150,
							},
							bottom: {
								[Breakpoints.default]: ContainerPadding.dynamic0200,
								[Breakpoints.b560]: ContainerPadding.dynamic0150,
							},
						}}
						wrap="always"
						gutter={ContainerGutter.dynamic0100}
					>
						<Layout
							data-testid="novedades-title-layout"
							appearance={{
								[Breakpoints.default]: [
									{ name: '.', columns: 1 },
									{ name: 'novedades-title', columns: 22 },
									{ name: '.', columns: 1 },
								],
							}}
						>
							<Container data-testid="novedades-section-title" wrap="always">
								<Text
									appearance={TokenTextAppearance.bigcopy200}
									color={TokenTextColor.primary}
									textAlign={TextAlignment.left}
									bold
								>
									Novedades
								</Text>
								<Text
									appearance={TokenTextAppearance.headline500}
									color={TokenTextColor.primary}
									textAlign={TextAlignment.left}
								>
									Entérate de <b>lo último</b>
								</Text>
							</Container>
						</Layout>

						<Layout
							data-testid="novedades-carousel-layout"
							appearance={{
								[Breakpoints.default]: [{ name: 'novedades-carousel', columns: 24 }],
							}}
						>
							<NovedadesCarousel novedades={novedades} key="second_div" data-testid="novedades-carousel" />
						</Layout>
					</Container>
				) : (
					<StyledSpinner variant="x-large" />
				)}
			</section>
		</Background>
	);
};
